<button mat-flat-button class="gray" (click)="openAddEventDialog('300ms', '100ms')">
    Launch Dialog
</button>